import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoComponent {
    @Input() paddingLeft = false;
    @Input() paddingRight = false;
}
